import axios from "axios";
//todo change back
// const BASE_URL = "https://qanoon.net/";
const BASE_URL = "https://api.qanoon.net/";

export const subscribe = "https://dsplp.sd.zain.com/?p=8863864328";
// const BASE_URL = "https://164.92.166.12:1234/";

// const BASE_URL = "https://map.goteclabs.com:7000";

export default axios.create({
  baseURL: BASE_URL,
});
